import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NodeItem } from '../models/node.model';

@Component({
    selector: 'folder-tree',
    templateUrl: 'folder-tree.component.html',
    standalone: false
})
export class FolderTreeComponent implements OnInit {
  @Input() public nodes: NodeItem[];
  @Input() public options: any;

  @Output() public toggleOpenNode: EventEmitter<any> = new EventEmitter();
  @Output() public toggleExpandNode: EventEmitter<any> = new EventEmitter();
  @Output() public toggleCloseNode: EventEmitter<any> = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  openNode(node: NodeItem) {
    this.toggleOpenNode.emit(node);
  }

  showChildren(node: NodeItem, event: Event) {
    event.stopPropagation();
    node.showChildren = !node.showChildren;
    if (node.showChildren) {
      this.toggleExpandNode.emit(node);
    } else {
      this.toggleCloseNode.emit(node);
    }
  }

  hasFolders(node: NodeItem) {
    return node.children.some((n) => !n.fileNode);
  }
}
